import { CommodityI, OrderTypes, SalespersonI, SortByOptionsI } from "../../config/listOptions";

export const approvalsTypes = {
  FIX_UNFIX_SCORES               : "@APPROVALS/FIX_UNFIX_SCORES",
  CREATE_DEDICATED_OFFER         : "@APPROVALS/CREATE_DEDICATED_OFFER",
  CREATE_DEDICATED_OFFER_SUCCESS : "@APPROVALS/CREATE_DEDICATED_OFFER_SUCCESS",
  CREATE_DEDICATED_OFFER_FAILURE : "@APPROVALS/CREATE_DEDICATED_OFFER_FAILURE",
  CREATE_SINGLE_OFFER            : "@APPROVALS/CREATE_SINGLE_OFFER",
  CREATE_SINGLE_OFFER_SUCCESS    : "@APPROVALS/CREATE_SINGLE_OFFER_SUCCESS",
  CREATE_SINGLE_OFFER_FAILURE    : "@APPROVALS/CREATE_SINGLE_OFFER_FAILURE",
  UPDATE_OFFER_QUEUE             : "@APPROVALS/UPDATE_OFFER_QUEUE",
  UPDATE_OFFER_QUEUE_SUCCESS     : "@APPROVALS/UPDATE_OFFER_QUEUE_SUCCESS",
  UPDATE_OFFER_QUEUE_FAILURE     : "@APPROVALS/UPDATE_OFFER_QUEUE_FAILURE",
  GET_APPROVALS_QUEUE            : "@APPROVALS/GET_APPROVALS_QUEUE",
  GET_APPROVALS_QUEUE_SUCCESS    : "@APPROVALS/GET_APPROVALS_QUEUE_SUCCESS",
  GET_APPROVALS_QUEUE_FAILURE    : "@APPROVALS/GET_APPROVALS_QUEUE_FAILURE",
  GET_ORDERS                     : "@APPROVALS/GET_ORDERS",
  GET_ORDERS_SUCCESS             : "@APPROVALS/GET_ORDERS_SUCCESS",
  GET_ORDERS_FAILURE             : "@APPROVALS/GET_ORDERS_FAILURE",
  GET_USERS                      : "@APPROVALS/GET_USERS",
  GET_USERS_SUCCESS              : "@APPROVALS/GET_USERS_SUCCESS",
  GET_USERS_FAILURE              : "@APPROVALS/GET_USERS_FAILURE",
  GET_LOCATIONS                  : "@APPROVALS/GET_LOCATIONS",
  GET_LOCATIONS_SUCCESS          : "@APPROVALS/GET_LOCATIONS_SUCCESS",
  GET_LOCATIONS_FAILURE          : "@APPROVALS/GET_LOCATIONS_FAILURE",
  GET_EQUIPMENT_TYPES            : "@APPROVALS/GET_EQUIPMENT_TYPES",
  GET_EQUIPMENT_TYPES_SUCCESS    : "@APPROVALS/GET_EQUIPMENT_TYPES_SUCCESS",
  GET_EQUIPMENT_TYPES_FAILURE    : "@APPROVALS/GET_EQUIPMENT_TYPES_FAILURE",
  GET_CARRIERS                   : "@APPROVALS/GET_CARRIERS",
  GET_CARRIERS_SUCCESS           : "@APPROVALS/GET_CARRIERS_SUCCESS",
  GET_CARRIERS_FAILURE           : "@APPROVALS/GET_CARRIERS_FAILURE",
  SET_FILTERS                    : "@APPROVALS/SET_FILTERS",
  LOAD_MORE                      : "@APPROVALS/LOAD_MORE",
  DELETE_APPROVAL_QUEUE          : "@APPROVALS/DELETE_APPROVAL_QUEUE",
  DELETE_APPROVAL_QUEUE_SUCCESS  : "@APPROVALS/DELETE_APPROVAL_QUEUE_SUCCESS",
  DELETE_APPROVAL_QUEUE_FAILURE  : "@APPROVALS/DELETE_APPROVAL_QUEUE_FAILURE",
  UPDATE_STATUS_QUEUE            : "@APPROVALS/UPDATE_STATUS_QUEUE",
  UPDATE_STATUS_QUEUE_SUCCESS    : "@APPROVALS/UPDATE_STATUS_QUEUE_SUCCESS",
  UPDATE_STATUS_QUEUE_FAILURE    : "@APPROVALS/UPDATE_STATUS_QUEUE_FAILURE",
  GET_APPROVALS_HISTORY          : "@APPROVALS/GET_APPROVALS_HISTORY",
  GET_APPROVALS_HISTORY_SUCCESS  : "@APPROVALS/GET_APPROVALS_HISTORY_SUCCESS",
  GET_APPROVALS_HISTORY_FAILURE  : "@APPROVALS/GET_APPROVALS_HISTORY_FAILURE",
  SET_FILTERS_HISTORY            : "@APPROVALS/SET_FILTERS_HISTORY",
  LOAD_MORE_HISTORY              : "@APPROVALS/LOAD_MORE_HISTORY",
  FIX_UNFIX_SCORES_HISTORY       : "@APPROVALS/FIX_UNFIX_SCORES_HISTORY",
  SHOW_LAST_DATA                 : "@APPROVALS/SHOW_LAST_DATA",
  SHOW_LAST_DATA_SUCCESS         : "@APPROVALS/SHOW_LAST_DATA_SUCCESS",
  SHOW_LAST_DATA_FAILURE         : "@APPROVALS/SHOW_LAST_DATA_FAILURE",
};

export interface ApprovalsStateI {
  approvalsLoading: boolean;
  approvalsError: string;
  orders: Array<OrderI>;
  approvals: Array<ApprovalI>;
  approvalsHistory: Array<ApprovalI>;
  areScoresFixed: boolean;
  loadPage: boolean;
  loadingLastLoads: boolean;
  filters: ApprovalFiltersI;
  noMore: boolean;
  newOfferLoading: boolean;
  newOfferError: string;
  updateOfferLoading: boolean;
  updateOfferError: string;
  users: Array<UserI>;
  locations: Array<LocationI>;
  equipmentTypes: Array<EquipmentTypeI>;
  carriers: Array<CarrierI>;
  loadMore: boolean;
  loadingDeleteApproval: boolean;
  updateStatusLoading: boolean;
  loadMoreHistory: boolean;
  loadPageHistory: boolean;
  noMoreHistory: boolean;
  filtersHistory: ApprovalFiltersI;
  areScoresFixedHistory: boolean;
}
export interface GetApprovalsQueueI {
  type: typeof approvalsTypes.GET_APPROVALS_QUEUE;
  payload?: ApprovalFiltersI;
}

export interface GetApprovalsQueueSuccessI {
  type: typeof approvalsTypes.GET_APPROVALS_QUEUE_SUCCESS;
  payload: Array<ApprovalI>;
}

export interface GetApprovalsQueueFailureI {
  type: typeof approvalsTypes.GET_APPROVALS_QUEUE_FAILURE;
  payload?: string;
}

export interface LoadMoreI {
  type: typeof approvalsTypes.LOAD_MORE;
  payload: number;
}
export interface GetOrdersI {
  type: typeof approvalsTypes.GET_ORDERS;
  payload?: string;
}

export interface GetOrdersSuccessI {
  type: typeof approvalsTypes.GET_ORDERS_SUCCESS;
  payload: Array<OrderI>;
}

export interface GetOrdersFailureI {
  type: typeof approvalsTypes.GET_ORDERS_FAILURE;
  payload?: string;
}

export interface GetUsersI {
  type: typeof approvalsTypes.GET_USERS;
  payload?: string;
}

export interface GetUsersSuccessI {
  type: typeof approvalsTypes.GET_USERS_SUCCESS;
  payload: UserI;
}

export interface GetUsersFailureI {
  type: typeof approvalsTypes.GET_USERS_FAILURE;
  payload?: string;
}

export interface GetLocationsI {
  type: typeof approvalsTypes.GET_LOCATIONS;
  payload?: string;
}

export interface GetLocationsSuccessI {
  type: typeof approvalsTypes.GET_LOCATIONS_SUCCESS;
  payload: LocationI;
}

export interface GetLocationsFailureI {
  type: typeof approvalsTypes.GET_LOCATIONS_FAILURE;
  payload?: string;
}

export interface GetEquipmentTypesI {
  type: typeof approvalsTypes.GET_EQUIPMENT_TYPES;
  payload?: string;
}

export interface GetEquipmentTypesSuccessI {
  type: typeof approvalsTypes.GET_EQUIPMENT_TYPES_SUCCESS;
  payload: EquipmentTypeI;
}

export interface GetEquipmentTypesFailureI {
  type: typeof approvalsTypes.GET_EQUIPMENT_TYPES_FAILURE;
  payload?: string;
}

export interface GetCarriersI {
  type: typeof approvalsTypes.GET_CARRIERS;
  payload?: string;
}

export interface GetCarriersSuccessI {
  type: typeof approvalsTypes.GET_CARRIERS_SUCCESS;
  payload: CarrierResponseI;
}

export interface GetCarriersFailureI {
  type: typeof approvalsTypes.GET_CARRIERS_FAILURE;
  payload?: string;
}

export interface UpdateSingleOfferModelI {
  approval_id: number;
  carrier_id: string;
  rate: number | null;
  comments?: string;
  commission?: number;
}
export interface UpdateDedicatedOfferModelI {
  approval_id: number;
  origin_id?: number;
  destination_id?: number;
  carrier_id: string;
  rate: number | null;
  comments?: string;
}

export interface CreateDedicatedOfferI {
  type: typeof approvalsTypes.CREATE_DEDICATED_OFFER;
  payload: DedicatedOfferModelI;
  cbSuccess: () => void;
  cbFailure: (error: string) => void;
}

export interface CreateDedicatedOfferSuccessI {
  type: typeof approvalsTypes.CREATE_DEDICATED_OFFER_SUCCESS;
  payload?: ObjectI;
}

export interface CreateDedicatedOfferFailureI {
  type: typeof approvalsTypes.CREATE_DEDICATED_OFFER_FAILURE;
  payload: string;
}

export interface CreateSingleOfferI {
  type: typeof approvalsTypes.CREATE_SINGLE_OFFER;
  payload: SingleOfferModelI;
  cbSuccess: () => void;
  cbFailure: (error: string) => void;
}

export interface CreateSingleOfferSuccessI {
  type: typeof approvalsTypes.CREATE_SINGLE_OFFER_SUCCESS;
  payload?: ObjectI;
}

export interface CreateSingleOfferFailureI {
  type: typeof approvalsTypes.CREATE_SINGLE_OFFER_FAILURE;
  payload: string;
}

export interface UpdateOfferQueueI {
  type: typeof approvalsTypes.UPDATE_OFFER_QUEUE;
  payload: UpdateSingleOfferModelI | UpdateDedicatedOfferModelI;
  cbSuccess: () => void;
  cbFailure: (error: string) => void;
}

export interface UpdateOfferQueueSuccessI {
  type: typeof approvalsTypes.UPDATE_OFFER_QUEUE_SUCCESS;
  payload?: ObjectI;
}

export interface UpdateOfferQueueFailureI {
  type: typeof approvalsTypes.UPDATE_OFFER_QUEUE_FAILURE;
  payload: string;
}

export interface DeleteApprovalQueueI {
  type: typeof approvalsTypes.DELETE_APPROVAL_QUEUE;
  payload: DeleteApprovalPayloadI;
  successCallback: () => void;
  failureCallback: (error: string) => void;
}

export interface DeleteApprovalQueueSuccessI {
  type: typeof approvalsTypes.DELETE_APPROVAL_QUEUE_SUCCESS;
  payload: DeleteApprovalPayloadI;
}

export interface DeleteApprovalQueueFailureI {
  type: typeof approvalsTypes.DELETE_APPROVAL_QUEUE_FAILURE;
  payload: string;
}

export interface UpdateStatusQueueI {
  type: typeof approvalsTypes.UPDATE_STATUS_QUEUE;
  payload: UpdateStatusPayloadI;
  successCallback: () => void;
  failureCallback: (error: string) => void;
}

export interface UpdateStatusQueueSuccessI {
  type: typeof approvalsTypes.UPDATE_STATUS_QUEUE_SUCCESS;
  payload: ApprovalI;
}

export interface UpdateStatusQueueFailureI {
  type: typeof approvalsTypes.UPDATE_STATUS_QUEUE_FAILURE;
  payload: string;
}

export interface GetApprovalsHistoryI {
  type: typeof approvalsTypes.GET_APPROVALS_HISTORY;
  payload?: ApprovalFiltersI;
}

export interface GetApprovalsHistorySuccessI {
  type: typeof approvalsTypes.GET_APPROVALS_HISTORY_SUCCESS;
  payload: Array<ApprovalI>;
}

export interface GetApprovalsHistoryFailureI {
  type: typeof approvalsTypes.GET_APPROVALS_HISTORY_FAILURE;
  payload?: string;
}

export interface LoadMoreHistoryI {
  type: typeof approvalsTypes.LOAD_MORE_HISTORY;
  payload: number;
}

export type ShowLastDataPayload = {
  section: "queue" | "history";
}
export interface ShowLastDataI {
  type: string;
  payload: ShowLastDataPayload;
}
export interface ShowLastDataSuccessI {
  type: string;
  payload: {
    approvals: Array<ApprovalI>;
    showMessage: boolean;
    section: "queue" | "history";
  };
}

export interface ShowLastDataFailureI {
  type: string;
  payload: string;
}

export type getApprovalsTypes =
  | GetApprovalsQueueI
  | GetApprovalsQueueSuccessI
  | GetApprovalsQueueFailureI
  | GetOrdersI
  | GetOrdersSuccessI
  | GetOrdersFailureI
  | CreateDedicatedOfferI
  | CreateDedicatedOfferSuccessI
  | CreateDedicatedOfferFailureI
  | CreateSingleOfferI
  | CreateSingleOfferSuccessI
  | CreateSingleOfferFailureI
  | UpdateOfferQueueI
  | UpdateOfferQueueSuccessI
  | UpdateOfferQueueFailureI
  | GetUsersI
  | GetUsersSuccessI
  | GetUsersFailureI
  | GetLocationsI
  | GetLocationsSuccessI
  | GetLocationsFailureI
  | GetEquipmentTypesI
  | GetEquipmentTypesSuccessI
  | GetEquipmentTypesFailureI
  | GetCarriersI
  | GetCarriersSuccessI
  | GetCarriersFailureI
  | LoadMoreI
  | UpdateStatusQueueI
  | UpdateStatusQueueSuccessI
  | UpdateStatusQueueFailureI
  | DeleteApprovalQueueI
  | DeleteApprovalQueueSuccessI
  | DeleteApprovalQueueFailureI
  | GetApprovalsHistoryI
  | GetApprovalsHistorySuccessI
  | GetApprovalsHistoryFailureI
  | LoadMoreHistoryI

export type ApprovalFiltersI = {
  ignore_default_time_filter?: boolean;
  user_id?: string;
  approval_id?: number;
  order_number?: string;
  equipment_type?: Array<EquipmentTypeI>;
  commodity?: Array<CommodityI>;
  carrier?: Array<CarrierI>;
  salesperson?: SalespersonI;
  destination?: Array<LocationI>; // Must have the format city, state_id
  origin?: Array<LocationI>; //	Must have the format city, state_id
  pick_up_date?: string;
  drop_off_date?: string;
  distance_from?: SortByOptionsI;
  distance?: SortByOptionsI;
  dispatcher?: UserI;
  limit: number;
  page: number;
  sort_by: SortByOptionsI;
  order_by: OrderTypes;
  dispatch_division?: DispatchDivisionI;
  [props: string]: any;
}

export type UpdateStatusValuesI = {
  status: {
    id: string;
    description: string;
  };
  status_comment: string;
}

export type ApprovalI = {
  approval_id: number;
  type: RateType;
  rate: number | null;
  max_buy: number;
  lookup_rate: number | null;
  fw_rate: number | null;
  comments: string | null;
  market_scores: MarketScoresI;
  dispatcher: string | null;
  carrier_id: string | null;
  order_comments?: string;
  origin_id: string | null;
  destination_id: string | null;
  equipment_type_id: string | null;
  status: StatusTypes;
  created_at: string;
  updated_at: string;
  movement_number: string | null;
  order_number: string;
  distance: number;
  weight: number;
  section: "queue" | "history";
  commodity: string;
  ship_date: string;
  ordered_date: string;
  origin: OriginI;
  destination: DestinationI;
  equipment_type: EquipmentTypeI;
  carrier: CarrierI;
  stops: Array<StopI>;
  isLast: boolean;
  counter_offer?: number;
  commission?: number | string;
  status_comment?: string;
  total_charge?: string;
  creation_source?: string;
}

export type ApprovalsLogsFiltersI = {
  page: number;
  limit: 5;
  carrier?: CarrierI;
  origin?: OriginI;
  destination?: DestinationI;
  equipment_type?: EquipmentTypeI;
  order_number?: string;
  pick_up_date?: string;
  drop_off_date?: string;
  status?: string;
  sort_by?: string;
  order_by?: string;
}

export type OrderI = {
  loads_destination: LoadI;
  loads_origin: LoadI;
  movementNumber: string;
  orderNumber: string;
  market_scores: MarketScoresI;
  max_buy: number | null;
  lookup_rate: number | null;
  fw_rate: number | null;
  equipment_type: EquipmentTypeI;
  distance: number;
  stopsCount: number;
  total_charge: number | null;
  loads_stops: Array<LoadI>;
  origin: LocationI;
  destination: LocationI;
}

export type UserI = {
  user_id: string | null;
  email: string;
  auth0_id: string;
  phone_number: string | null;
  status: boolean;
  name: string;
  role_id: string | null;
  created_at: string;
  updated_at: string;
  role: RoleI;
  dispatcher: string;
}

export interface StopI {
  sequence_number: number;
  arrive_early_time: string;
  arrive_early_time_offset: number | null;
  arrive_late_time: string | null;
  arrive_late_time_offset: number | null;
  arrivals: Array<ArrivalsI>;
  address: string;
  location: string;
  city: string;
  state: string;
  stateCode: string;
  zip_code: string;
  stop_id: string;
  market: string | null;
}

export interface LocationI {
  location_id: number;
  city_id: number;
  city: string;
  state_id: string;
  timezone: string;
  offset: number;
  is_capital: number;
  state: string;
  country: string;
  capital: string;
  latitude: string | null;
  longitude: string | null;
  zip_code: string;
  market?: string | null;
}

export interface LoadI {
  arrive_early_datetime: string | null;
  arrive_early_datetime_offset: number | null;
  arrive_late_datetime: string | null;
  arrive_late_datetime_offset: number | null;
  city: string;
  latitude: number;
  longitude: number;
  market: null;
  movementNumber: string;
  state_code: string;
  zipCode: string;
}

export interface CustomerI {
  customer_id?: string;
  name?: string;
  salesperson_id?: string;
}

export interface ArrivalsI {
  date: string;
  offset: number | null;
}

export interface SingleOfferModelI {
  carrier_id: string;
  movement_number: string;
  rate: number;
  comments?: string;
  commission: number;
}

export interface DedicatedOfferModelI {
  carrier_id: string;
  origin_id: number;
  destination_id: number;
  equipment_type_id: string;
  rate: number;
  comments?: string;
}

export interface OriginI {
  state_code?: string;
  arrive_early_datetime?: string;
  arrive_late_datetime?: string | null;
  city?: string;
  zip_code?: string;
  market?: string | null;
  location_id?: number;
  state_id?: string;
  state?: string;
  country?: string;
  capital?: string;
  latitude?: number;
  longitude?: number;
}

export interface DestinationI {
  state_code?: string;
  arrive_early_datetime?: string;
  arrive_late_datetime?: string | null;
  city?: string;
  zip_code?: string;
  market?: string | null;
  location_id?: number;
  state_id?: string;
  state?: string;
  country?: string;
  capital?: string;
  latitude?: number;
  longitude?: number;
}

export interface RoleI {
  role_id: string;
  is_custom_role: boolean;
  name: string;
  description: string;
}

export interface EquipmentTypeI {
  equipment_code: string;
  description?: string;
}

export interface CarrierI {
  carrier_id: string;
  address_1: string;
  name: string;
  salesperson_id: string | null;
  dot_number: string | null;
  mc_number: string | null;
  status?: "A" | "I" | "N";
  no_dispatch?: boolean;
}

export interface MarketScoresI {
  backhaul_month: number | null;
  composite_score: number | null;
  destination_capacity_trend_percentage: number | null;
  destination_cts_52: number | null;
  dms: number | null;
  drv: number | null;
  headhaul_month: number | null;
  itms: number | null;
  itms_avg: number | null;
  itri: number | null;
  oms: number | null;
  origin_capacity_trend_percentage: number | null;
  origin_cts_52: number | null;
  orv: number | null;
  otms: number | null;
  otms_avg: number | null;
  otri: number | null;
}

export interface SingleOfferI {
  order_number: string;
  distance: number;
  equipment_type: EquipmentTypeI;
  rate: number;
  weight: number;
  comments: string;
  commodity: null;
  ship_date: string;
  ordered_date: null;
  approval_id: number;
  type: string;
  max_buy: number;
  lookup_rate: null;
  market_scores: MarketScoresI;
  user_id: string;
  carrier_id: string;
  movement_number: string;
  origin_id: null;
  destination_id: null;
  equipment_type_id: null;
  origin: OriginI;
  destination: DestinationI;
  carrier: CarrierI;
  stops: Array<StopI>;
}

export enum RateType {
  single = "single",
  dedicated = "dedicated",
}

export enum StatusTypes {
  approved = "approved",
  rejected = "rejected",
  counter = "counter",
}

export enum ApprovalSection {
  queue = "queue",
  history = "history",
}

export interface ObjectI {
  [props: string]: string | any;
}

export interface StopI {
  sequence_number: number;
  arrive_early_time: string;
  arrive_early_time_offset: number | null;
  arrive_late_time: string | null;
  arrive_late_time_offset: number | null;
  arrivals: Array<ArrivalsI>;
  address: string;
  location: string;
  city: string;
  state: string;
  stateCode: string;
  zip_code: string;
  stop_id: string;
  market: string | null;
  stop_type?: string;
  latitude: string | null;
  longitude: string | null;
}

export interface CarrierResponseI {
  carrier_id: string;
  address1: string;
  address2: string | null;
  check_address: string;
  check_address2: string | null;
  check_city: string | null;
  check_name: string | null;
  check_state: string | null;
  check_zip: string | null;
  city: string;
  email: string;
  name: string;
  phone_number: string | null;
  state: string;
  zip_code: string;
  contact_name: string | null;
  salesperson_id: string | null;
  dot_number: string;
  mc_number: null;
  status?: "A" | "I" | "N";
  no_dispatch?: boolean;
  createdAt: string | null;
  updatedAt: string | null;
}
export interface CustomerI {
  customer_id?: string;
  name?: string;
  salesperson_id?: string;
}

export interface ArrivalsI {
  date: string;
  offset: number | null;
}

export interface RoleI {
  role_id: string;
  is_custom_role: boolean;
  name: string;
  description: string;
}

export interface DispatchDivisionI {
  dispatch_division_id: number;
  country: string;
  city?: string;
}

export interface SingleOfferI {
  order_number: string;
  distance: number;
  equipment_type: EquipmentTypeI;
  rate: number;
  weight: number;
  comments: string;
  commodity: null;
  ship_date: string;
  ordered_date: null;
  approval_id: number;
  type: string;
  max_buy: number;
  lookup_rate: null;
  market_scores: MarketScoresI;
  user_id: string;
  carrier_id: string;
  movement_number: string;
  origin_id: null;
  destination_id: null;
  equipment_type_id: null;
  origin: OriginI;
  destination: DestinationI;
  carrier: CarrierI;
  stops: Array<StopI>;
}

export interface DedicatedOfferI {
  approval_id: number;
  type: string;
  rate: number;
  max_buy: number;
  comments: string;
  lookup_rate: null;
  market_scores: MarketScoresI;
  user_id: string;
  distance: number;
  carrier_id: string;
  movement_number: null;
  origin_id: number;
  destination_id: number;
  equipment_type_id: string;
  origin: OriginI;
  destination: DestinationI;
  carrier: CarrierI;
}

export type LoadDispatch = {
  movementNumber: string;
  carrier_id: string;
  driver_name: string;
  driver_phone_number: string;
  driver_email?: string;
  dispatcher_id: string;
  dispatcher_name: string;
  dispatcher_phone_number: string;
  dispatcher_email: string;
  override_rate: string;
  trailer_number: string;
  tractor_number: string;
}

export type OrderDetails = {
  orderNumber: string;
  movementNumber: string;
  available?: boolean;
  distance: number;
  equipmentType: string;
  rate?: string;
  lookup_rate?: string;
  on_hold: boolean;
  radius: number;
  weight: number;
  stopsCount: number;
  hot_offer: boolean;
  comments?: string;
  commodity: string;
  ship_date: string;
  ship_date_offset?: string;
  vin_number?: string;
  trailer_length?: string;
  loads_origin: LoadI;
  loads_destination: LoadI;
  loads_stops: [];
  loads_dispatch: LoadDispatch;
  equipment_type: EquipmentTypeI;
  market_scores: MarketScoresI;
}

export type CustomDetailsEquipmentLocation = {
  origin: LocationI;
  destination: LocationI;
  equipment_type: EquipmentTypeI;
  market_scores: MarketScoresI;
  lookup_rate?: number;
  distance?: number;
}
export type StatusOptionsI = "approved" | "counter" | "rejected"

export type ApprovalStatusFiltersI = {
  status: {
    id: string;
    description: string;
  };
  rate?: number;
  status_comment: string;
}

export interface UpdateStatusPayloadI {
  approval_id: number;
  status: StatusOptionsI;
  counter_offer?: number;
}

export interface SetApprovalI {
  type: string;
  payload: DeleteApprovalPayloadI;
}

export type DeleteApprovalPayloadI = {
  approval_id: number;
}

export type HistoryLogI = {
  rate: number;
  approval_id: number;
  status: string;
  type: string;
  max_buy?: number;
  origin?: {
    arrive_early_datetime: string;
  };
}

export type StepProps = {
  setParentTitle?: (value: string) => void;
  type?: RateType;
}
